export default __webpack_public_path__ + "static/media/visual-acuitytest.ee98abcb.png";